import React from 'react';
import { SearchIndexGroup, SearchIndexItem, SearchIndexType } from '@/types/search';
import axios from 'axios';
import _ from 'lodash';
export const MAX_PREVIEW_LENGTH = 80;

export const fetchSearchIndex = async (): Promise<SearchIndexItem[]> => {
  const res = await axios.get<SearchIndexGroup[]>(`/search-index.json`);
  const versionedData: SearchIndexItem[] = Object.entries(
    _.groupBy(
      res.data.flatMap((group) => group.items),
      (item) => {
        return item.type;
      },
    ),
  ).flatMap(([key, values]) =>
    values.map((value) => ({
      ...value,
      type: key as SearchIndexType,
    })),
  );

  return [...versionedData];
};

export const getClosestWords = (text: string, startIndex: number, endIndex: number) => {
  let newStartIndex = startIndex;
  let newEndIndex = endIndex;

  // If the start index is not at the beginning of the string,
  if (text[startIndex] && text[startIndex] !== ' ') {
    // find the previous space to start from
    const prevSpaceIndex = text.lastIndexOf(' ', startIndex);
    if (prevSpaceIndex !== -1) {
      newStartIndex = prevSpaceIndex + 1; // +1 to include the space
    }
  }

  // end index on whole word
  if (text[endIndex] && text[endIndex] !== ' ') {
    const nextSpaceIndex = text.indexOf(' ', endIndex);
    if (nextSpaceIndex !== -1) {
      newEndIndex = nextSpaceIndex;
    }
  }

  return [newStartIndex, newEndIndex];
};

export const getHighlight = (content: string, query: string) => {
  const start = content.toLowerCase().indexOf(query.toLowerCase());
  const end = start + query.length;

  let startIndex = Math.max(0, start - MAX_PREVIEW_LENGTH);
  let endIndex = Math.min(content.length, end + MAX_PREVIEW_LENGTH);

  [startIndex, endIndex] = getClosestWords(content, startIndex, endIndex);

  const textParts = [
    <span key="start">
      {startIndex > 0 && '...'}
      {content.slice(startIndex, start)}
    </span>,
    <strong key="middle" className="bg-purple-600/90 rounded-sm">
      {content.slice(start, end)}
    </strong>,
    <span key="end">
      {content.slice(end, endIndex)}
      {endIndex < content.length && '...'}
    </span>,
  ];

  return {
    textParts,
    longText: content.slice(startIndex, endIndex),
    text: content.slice(start, end),
    startIndex: start,
    endIndex: end,
  };
};
